module.exports = __webpack_public_path__ + "img/6d.06cfd2da.png";